/**
 * 대화 칩 줄 (SPEC_CHANGE_v1.3 23.7, 시안 12 P1~P3 · 결정 50 · 51, C-29 · D74)
 *
 * - 입력창 바로 위 고정 자리, 위 hairline, 패딩 10 16 0, flex-wrap 간격 8, 최대 2줄(넘치는 뒤 칩은 가려짐 = 낮은 순위부터 빠짐)
 * - 칩: 높이 36 · 패딩 0 14 · 모서리 18 6 18 18 · --surface-sunken · 14/500. 초상 없음(1:1 의 다른 멤버 칩은 팥 알약 + 초상 = 토스)
 * - 누르면 바로 보냄(눌림 80ms), 한 번 누르면 줄 전체가 꺼짐(연타 무시)
 * - role="group", 칩은 버튼 · 히트 44, 「{문구}, 누르면 바로 보내요」
 */
import { useState } from 'react';
import { getMember } from '@config/members/index.js';
import { Avatar } from './Avatar.jsx';

const GROUP_LABEL = { question: '답하기', light: '이어 말하기' };

export function ChipRow({ chips, onTap, surface = 'room' }) {
    const [pressed, setPressed] = useState(null);
    if (!chips?.items?.length) {
        return null;
    }
    const busy = pressed !== null;
    return (
        <div
            role="group"
            aria-label={GROUP_LABEL[chips.speechAct] ?? '말 꺼내기'}
            className="flex max-h-[80px] shrink-0 flex-wrap gap-2 overflow-hidden border-t border-hairline bg-bg px-4 pt-2.5"
        >
            {chips.items.map((item) => {
                const toss = surface === 'chat' && item.type === 'ask_other' && item.target;
                const isPressed = pressed === item.chipItemsId;
                return (
                    <button
                        key={item.chipItemsId}
                        type="button"
                        disabled={busy}
                        aria-label={`${item.text}, 누르면 바로 보내요`}
                        onClick={() => {
                            if (busy) {
                                return;
                            }
                            setPressed(item.chipItemsId);
                            onTap(item);
                        }}
                        className={`inline-flex h-9 min-h-9 items-center gap-1.5 rounded-[18px] rounded-tr-[6px] border px-3.5 text-[14px] leading-5 font-medium transition-transform duration-80 motion-reduce:transition-none ${
                            isPressed ? 'scale-[.97] border-brand bg-[#E2D6C3]' : 'border-transparent bg-surface-sunken'
                        } ${toss ? 'bg-brand-tint text-brand' : 'text-text-primary'} disabled:opacity-60`}
                    >
                        {toss ? <Avatar memberKey={item.target} size={20} /> : null}
                        <span>{item.text}</span>
                        {toss ? <span className="sr-only">{getMember(item.target)?.name}에게 넘기기</span> : null}
                    </button>
                );
            })}
        </div>
    );
}
